import type { CatalogSet, Resolver, ResolveContext } from "./types";

const BASE_LOCALE = "en";

export function makeResolver(catalogs: CatalogSet): Resolver {
  return function resolve(key: string, context: ResolveContext): string {
    const { locale, audience } = context;
    // When audience is "family", candidates 1/2 (and 3/4) are the same lookup; kept uniform so the fallback order reads consistently.
    const candidates: (string | undefined)[] = [
      catalogs[locale]?.[audience]?.[key],
      catalogs[locale]?.family?.[key],
      catalogs[BASE_LOCALE]?.[audience]?.[key],
      catalogs[BASE_LOCALE]?.family?.[key],
    ];
    for (const candidate of candidates) {
      if (candidate !== undefined) return candidate;
    }
    throw new Error(`i18n: missing key "${key}" (locale=${locale}, audience=${audience}); not found in en/family`);
  };
}
